import { Contract } from "@/components/Contracts/contract.interface";
import {
  OperationInternalName,
  OperationType
} from "@/modules/Settings/pages/Operations/enum";
import { ServicesCategoriesTypesEnum } from "@/modules/Settings/types/ServicesCategories.types";

type CarrierName = "TIM" | "VIVO" | "CLARO";

type OperationsNotAllowedByCarrier = Record<
  CarrierName,
  OperationInternalName[]
>;

const operationsNotAllowedByCarrier: OperationsNotAllowedByCarrier = {
  TIM: [OperationInternalName.STANDARD_PORTABILITY],
  VIVO: [],
  CLARO: []
};
export const shouldHaveOwnershipTransfer = (currentContract: Contract) => {
  const isBringYourOwn = currentContract?.items?.every(
    item => item?.operation?.type === OperationType.BRING_YOUR_OWN
  );

  const isMobileLine =
    currentContract.serviceCategory.type ===
    ServicesCategoriesTypesEnum.MOBILE_LINE;

  const isAllowedOperation = currentContract.items?.some(item => {
    const carrierName = item.offerPrice.offer.plan.carrier.name.toUpperCase();

    const notAllowedOperations = operationsNotAllowedByCarrier[carrierName];

    return !notAllowedOperations?.includes(item.operation.internalName);
  });

  return isBringYourOwn && isMobileLine && isAllowedOperation;
};
